const cache = {}
const reverseCache = {}
function toFB( key ) {
  if ( key == null ) {
    return key
  }
  if ( cache[key] ) {
    return cache[key]
  } 
  cache[key] = key.replaceAll( '.', ':' )
  reverseCache[cache[key]] = key
  return cache[key]
}

function fromFB( key ) {
  if ( key == null ) {
    return key
  }
  if ( reverseCache[key] ) {
    return reverseCache[key]
  } 
  reverseCache[key] = key.replaceAll( ':', '.' )
  return reverseCache[key]
}

export default {
  toFB,
  fromFB
}
